module.exports = __webpack_public_path__ + "static/media/unlink.cedb2f27.svg";